import { useRedux } from 'hooks/index';
import { solutionUserFilter, solutionUserViewAll, solutionUserViewDetails } from '../../redux/problem/solution/actions';

export default function useSolution() {
    const { dispatch, appSelector } = useRedux();

    const { loading, error, userSolutionDetails, userFilteredSolutions, userAllSolutions } = appSelector((state) => ({
        loading: state.ProblemSolution.loading,
        userAllSolutions: state.ProblemSolution.userAllSolutions,
        userSolutionDetails: state.ProblemSolution.userSolutionDetails,
        userFilteredSolutions: state.ProblemSolution.userFilteredSolutions,
        error: state.ProblemSolution.error,
    }));

    const userLoadAllSolution = (page: number, size: number) => {
        dispatch(solutionUserViewAll(page, size));
    };

    const userLoadSolutionDetails = (id: string) => {
        dispatch(solutionUserViewDetails(id));
    };

    const userLoadSolutionForProblem = (id: string, page: number, size: number) => {
        dispatch(solutionUserFilter(id, page, size));
    };

    return {
        error,
        loading,
        userSolutionDetails,
        userFilteredSolutions,
        userAllSolutions,
        userLoadAllSolution,
        userLoadSolutionDetails,
        userLoadSolutionForProblem,
    };
}
